import { AppBar, Typography, Button, Box, Container, Stack } from '@mui/material';
import osperb from 'assets/img/osperb/osperb25.png';
import useDevice from 'hooks/useDevice';
import { useState, useEffect } from 'react';
import { FaPhoneVolume } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

//images & colors
import { colors } from '../assets/config';
import CallBackModal from '../components/common/CallBackModal';

type DefaultNavbarProps = {
  isDark?: boolean;
};

export default function DefaultNavbar({ isDark }: DefaultNavbarProps) {
  const [showModal, setShowModal] = useState(false);
  const path = window.location.pathname;
  const { isMobile } = useDevice();

  // scroll direction tracking start
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [scrollDirection, setScrollDirection] = useState<string>();

  const listener = () => {
    const currentScroll = window.scrollY || document.documentElement.scrollTop;
    if (currentScroll <= 0) {
      setScrollDirection('down');
    } else {
      setScrollDirection(lastScrollTop >= currentScroll ? 'down' : 'up');
    }
    setLastScrollTop(currentScroll);
  };

  useEffect(() => {
    window.addEventListener('scroll', listener);
    return () => {
      window.removeEventListener('scroll', listener);
    };
  }, [lastScrollTop]);

  return (
    <>
      <CallBackModal showModal={showModal} setShowModal={setShowModal} />
      <div className="">
        <div className={`absolute w-full z-20 ${isDark ? '' : 'blend'} `}>
          <AppBar
            position="fixed"
            className={`navBarUl ${scrollDirection === 'up' ? 'ulHidden' : 'ulShow'
              } custom_nav w-100 pt-5`}
            sx={{ background: 'black', height: '70px' }}
          >
            <Container
              maxWidth="xl"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: isMobile ? '100%' : '100px',
                }}
              >
                <Link to="/" className="h-full nav-span">
                  <Box
                    component="img"
                    src={osperb}
                    alt="hero"
                    sx={{
                      width: '93px',
                      height: '30px',
                      borderRadius: 2,
                      objectFit: 'contain',
                    }}
                  />
                  {/* <Typography
                    style={{
                      color: colors.white,
                      background: 'black',
                      textTransform: 'none',
                    }}
                    className="font-typo"
                    variant="h3"
                    component="div"
                  >
                    osperb
                  </Typography> */}
                </Link>

                {isMobile && (
                  <Box className="flex flex-wrap items-center justify-between">
                    <span className="mx-5 sm:m-0" onClick={() => setShowModal(true)}>
                      <Button
                        className="bg-light ml-4 d-none-bigger sm:p-0"
                        style={{
                          color: colors.white,
                          background: 'black',
                          boxShadow: 'none',
                        }}
                      >
                        <a href="tel:+919562110055" title="Give me a call" className="queries">
                          <div className="sm:w-none qu_icon">
                            <FaPhoneVolume color={'white'} />
                          </div>
                          <Typography
                            style={{ fontWeight: '800', color: 'white' }}
                            className="font-popins text-sm"
                          >
                            +91 9562 110055
                          </Typography>
                        </a>
                      </Button>
                    </span>
                  </Box>
                )}
              </Box>

              {!isMobile && (
                <Box className="">
                  <Stack width={'100%'} flexDirection={'row'} alignItems={'center'} gap={4}>
                    <Button
                      component={Link}
                      to="/"
                      className={`underline-hover navItems ${path === '/' && 'full'} font-popins`}
                      sx={{
                        color: colors.white,
                        cursor: 'pointer',
                        px: 0,
                        py: 0.5,
                      }}
                      size="small"
                    >
                      <Typography variant="caption">HOME</Typography>
                    </Button>
                    <Button
                      component={Link}
                      to="/portfolio"
                      className={`underline-hover navItems ${path === '/portfolio' && 'full'
                        } font-popins`}
                      sx={{
                        color: colors.white,
                        cursor: 'pointer',
                        fontSize: '14px',
                        px: 0,
                        py: 0.5,
                      }}
                      size="small"
                    >
                      {/* Portfolio */}
                      <Typography variant="caption">PORTFOLIO</Typography>
                    </Button>

                    <Button
                      component={HashLink}
                      smooth={true}
                      to={`${path}#contact`}
                      className={`underline-hover 
                        navItems
                        ${path === '/#contact' && 'full'} font-popins`}
                      sx={{
                        color: colors.white,
                        cursor: 'pointer',
                        fontSize: '14px',
                        px: 0,
                        py: 0.5,
                      }}
                      size="small"
                    >
                      {/* Contact Us */}
                      <Typography variant="caption">CONTACT US</Typography>
                    </Button>
                    <span
                      onClick={() => setShowModal(true)}
                      className="d-none-smaller mx-5 navItems"
                    >
                      <Button
                        className="bg-light ml-4 navItems"
                        style={{
                          color: colors.white,
                          background: 'black',
                          boxShadow: 'none',
                        }}
                      >
                        <a href="tel:+919562110055" title="Give me a call" className="queries">
                          <div className="qu_icon">
                            <FaPhoneVolume />
                          </div>
                          <Typography className="font-popins text-sm" sx={{ fontWeight: '800' }}>
                            +91 9562 110055
                          </Typography>
                        </a>
                      </Button>
                    </span>
                  </Stack>
                </Box>
              )}
            </Container>
          </AppBar>
        </div>
        {/* {isMobile && (
          <>
            <div className="fixed w-full bottom-0 z-50 p-0">
              <div
                className="flex w-full justify-evenly bg-whitesmoke p-2"
                style={{ boxShadow: " 0px 1px 4px 3px rgb(0 0 0 / 10%)" }}
              >
                <Link
                  to="/"
                  className={`flex flex-column justify-center items-center ${path === "/" && "blue"
                    }`}
                >
                  <FaHome />
                  <Typography className="p-0 m-0 text-xsm">home</Typography>
                </Link>
                <Link
                  to="/portfolio"
                  className={`flex flex-column justify-center items-center ${path === "/portfolio" && "blue"
                    }`}
                >
                  <BsBookmarksFill />
                  <Typography className="p-0 m-0 text-xsm">Portfolio</Typography>
                </Link>
                <Link
                  to="/"
                  className={`${path === "/services" && "blue"
                    } flex flex-column justify-center items-center`}
                >
                  <MdHandyman />
                  <Typography className="p-0 m-0 text-xsm">Services</Typography>
                </Link>
                <HashLink
                  to={`${path}#contact`}
                  smooth={true}
                  className={`flex flex-column justify-center items-center ${path === `${path}#contact` && "blue"
                    }`}
                >
                  <RiContactsFill />
                  <Typography className="p-0 m-0 text-xsm">Contact Us</Typography>
                </HashLink>
              </div>
            </div>
          </>
        )} */}
      </div>
    </>
  );
}
